<mat-card appearance="outlined" class="highlights">
  <mat-card-header>
    <mat-card-title>
      {{ 'HIGHLIGHTS.HIGHLIGHTS' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="highlights-mat-card">
    <mat-nav-list>
      <ng-container *ngFor="let h of highlights">
        <a
          *ngIf="h?.routerLinkUrl as routerLinkUrl; else noRouter"
          class="highligh-item"
          mat-list-item
          [routerLink]="routerLinkUrl"
          [queryParams]="h?.routerLinkQueryParams"
          [attr.data-action]="h?.statusIcon === 'description' ? 'work-order-highlight-card' : 'highlight-card'"
        >
          <ng-container *ngTemplateOutlet="highlightContent; context: { h }"></ng-container>
        </a>
        <ng-template #noRouter>
          <a
            class="highligh-item"
            mat-list-item
            [href]="h.url"
            [attr.data-action]="h?.statusIcon === 'description' ? 'work-order-highlight-card' : 'highlight-card'"
          >
            <ng-container *ngTemplateOutlet="highlightContent; context: { h }"></ng-container>
          </a>
        </ng-template>
      </ng-container>
    </mat-nav-list>
  </mat-card-content>
</mat-card>

<ng-template #highlightContent let-h="h">
  <div class="highlight-content">
    <div class="desc">
      <mat-icon [class]="h.statusIconClass">
        {{ h.statusIcon }}
      </mat-icon>
      <span>{{ h.value }} {{ h.description }}</span>
    </div>
    <div class="link">
      {{ 'COMMON.ACTION_LABELS.VIEW' | translate }}
    </div>
  </div>
</ng-template>
